<template>
    <div>
        <el-row style="margin-bottom:10px;">
            <el-col :span="22" class="flex">
                <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-select v-model="theYatbId" clearable placeholder="请选择演练" size="small" style="max-width:150px;"
                    @change="getData">
                    <el-option v-for="(item, index) in getYcAiTrainBaseList_data.data || []" :key="index"
                        :label="item.yatbTitle" :value="item.yatbId"></el-option>
                </el-select>
                <el-select v-model="yatuStatus" clearable placeholder="请输入状态" size="small" style="max-width:150px;"
                    @change="getData">
                    <el-option label="未完成" :value="1"></el-option>
                    <el-option label="已完成" :value="2"></el-option>
                </el-select>

                <el-input v-model="getYcAiTrainUserList_data.yatbTitle" placeholder="请输入标题" clearable size="small"
                    style="max-width:200px;" />
                <el-input v-model="getYcAiTrainUserList_data.userName" placeholder="请输入用户名" clearable size="small"
                    style="max-width:200px;" />
                <el-date-picker v-model="valueDate" size='small' type="datetimerange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"
                    value-format="yyyy-MM-dd HH:mm:ss" align="right">
                </el-date-picker>
                <el-button v-click.getYcAiTrainUserList type="primary" icon="el-icon-search" size="small"
                    style="margin-left:10px;">搜索</el-button>
                <el-button @click="Bulksure()" type="success" icon="el-icon-search" size="small"
                    style="margin-left:10px;">导出
                </el-button>
                <el-button @click="Bulksure2()" type="success" icon="el-icon-search" size="small"
                    style="margin-left:10px;">导出Word
                </el-button>
            </el-col>
            <el-col :span="2"> </el-col>
        </el-row>

        <mytable ref="getYcAiTrainUserList" :tableColums="tableColums_getYcAiTrainUserList"
            api="getYcAiTrainUserList::yatuId" updateapi="updateMicrolectureTypeMain" :height="H - 165">
        </mytable>
        <el-dialog title="详情" :visible.sync="viedoDet" width="88%" :before-close="DeailClose">
            <el-table v-if="detailArr.ycAiTrainUserMsgList" :data="detailArr.ycAiTrainUserMsgList || []" border
                highlight-current-row :header-cell-style="{
                    textAlign: 'center',
                    background: 'rgba(0,170,255,0.5)',
                    color: 'black',
                    border: 'none'
                }" style="width: 100%;margin:12px 0 0 0;">
                <el-table-column type="index" width="50" label="序号" fixed="left">
                </el-table-column>
                <el-table-column prop="yuamrQuestion" label="问题">
                </el-table-column>
                <el-table-column prop="yuamrAnswer" label="答案" width="860">
                    <template slot-scope="scope">
                        <div style="width: 100%;height: 100%;" v-html="scope.row.yuamrAnswer">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" width="160">
                </el-table-column>
            </el-table>
            <div style="width: 100%;height: 300px;">
                <div ref="eCharts1" style="width: 80%;height: 100%; margin: 20px auto;"></div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import aplayer from "vue-aplayer";
import echarts from "echarts";
export default {
    components: {
        aplayer
    },
    data() {
        return {
            // getYcAiTrainBaseList_data:[],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            valueDate: "",
            theYatbId: "",
            examType: "",
            valueDate: "",
            ymtmTimeSubmitStart: "",
            ymtmTimeSubmitEnd: "",
            dtId: "",
            baseUrl: $Api.baseUrl_online,
            audio2: [],
            audioShow: false,
            audio: null,
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            echartsStr: "",
            echartsStrValue: [],
            yatuStatus: "",
            microlectureTitle: "",
            getMicrolectureTypeMainList_data: [],
            theUserProject: "",
            theProjectId: "",
            detailArr: [],
            viedoDet: false,
            mtmId: null,

            tableColums_getYcAiTrainUserList: {
                $selection: true,

                yatbTitle: "标题",
                yatcName: ["分类", 140],
                yatuTitleShow: ["演练记录标题", 180],
                // dtName: ["战队", 120],

                createusername: ["学员", 100],
                yatuScore: ["得分", 80],
                yatbScorePass: ["通过分数", 90],
                yatuStatus: [
                    "状态",
                    80,
                    "@v-if: 2:已完成 #(--Themecolor),  3:已中断 #warn,1:未完成 #danger"
                ],
                // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
                yatbTimeSubmit: ["提交时间", 150],
                createtime: ["创建时间", 150],
                $operation: [
                    "操作",
                    100,
                    `@text: 详情#success @click: handelDetail($row)`
                ]
            }
        };
    },

    watch: {},

    methods: {
        DeailClose() {
            this.viedoDet = false;
            this.echartsStrValue = {
                xdata: [],
                data: []
            };
            this.detailArr = [];
        },
        timeChange(e) {
            if (e) {
                this.getYcAiTrainUserList_data.dateTimeStart = e[0];
                this.getYcAiTrainUserList_data.dateTimeEnd = e[1];
            } else {
                this.getYcAiTrainUserList_data.dateTimeStart = "";
                this.getYcAiTrainUserList_data.dateTimeEnd = "";
            }
        },
        theDtChange(e) {
            this.dtId = e;
            this.$refs.cascader.dropDownVisible = false;
            this.getData();
        },
        audioClick(row) {
            this.audio2 = [];
            const s = {
                title: "录音",
                artist: "",
                src: row.ymtAudioPath,
                pic: 'https://eos-shanghai-2.cmecloud.cn/aojv/interview/682c50e8278747d280437f3a438b990e.png', // prettier-ignore
                lrc: ""
            };
            this.audio2.push(s);
            this.audioShow = true;
        },
        onEnded() {
            this.audio2 = [];
            this.audioShow = false;
        },
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Bulksure() {
            const bulkdata = {
                projectId: this.theProjectId,
                yatbTitle: this.getYcAiTrainUserList_data.yatbTitle,
                userName: this.getYcAiTrainUserList_data.userName,
                yatuStatus: this.yatuStatus,
                yatbId: this.theYatbId,
                dateTimeStart: this.getYcAiTrainUserList_data.dateTimeStart,
                dateTimeEnd: this.getYcAiTrainUserList_data.dateTimeEnd,
                exportMax: this.getYcAiTrainUserList_data.exportMax,
            };
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this;
            axios({
                method: "post",
                url:
                    that.baseUrl +
                    "/opportunity/yc-ai-train-user/exportYcAiTrainUserList",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    token: A.local("$Usertoken"),
                    projectId: +A.local("$projectId")
                }
            }).then(function (res) {
                if (res.data) {
                    that.loading.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "训练记录.xlsx");
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                }
            });
        },
        Bulksure2() {
            const selection = Object.keys(this.$refs.getYcAiTrainUserList.$MyTableCache);
            const bulkdata = {
                projectId: this.theProjectId,
                yatbTitle: this.getYcAiTrainUserList_data.yatbTitle,
                userName: this.getYcAiTrainUserList_data.userName,
                yatuStatus: this.yatuStatus,
                yatbId: this.theYatbId,
                dateTimeStart: this.getYcAiTrainUserList_data.dateTimeStart,
                dateTimeEnd: this.getYcAiTrainUserList_data.dateTimeEnd,
                yatuIds: selection.join(),
                exportMax: this.getYcAiTrainUserList_data.exportMax,
            };
            this.openLoading();
            var s = qs.stringify(bulkdata);
            var that = this;
            axios({
                method: "post",
                url:
                    that.baseUrl +
                    "/opportunity/yc-ai-train-user/exportYcAiTrainUserListWord",
                data: s,
                withCredentials: true,
                timeout: 1200000,
                responseType: "arraybuffer",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    token: A.local("$Usertoken"),
                    projectId: +A.local("$projectId")
                }
            }).then(function (res) {
                if (res.data) {
                    console.log(that.$refs.getYcAiTrainUserList.$MyTableCache);
                    that.$refs.getYcAiTrainUserList.Table.clearSelection();
                    that.loading.close();
                    let a = document.createElement("a");
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/zip"
                    });

                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", "训练记录.zip");
                    a.click();
                    console.log(that.$refs.getYcAiTrainUserList);

                    that.$message({
                        message: "成功",
                        type: "success"
                    });
                }
            });
        },
        play(row) {
            if (this.audio != null && !this.audio.paused) {
                this.audio.pause();
            }
            if (this.audio == null) {
                this.audio = new Audio();
            }
            this.audio.src = row;
            this.audio.play();
        },
        Preview(url) {
            document.PreviewVideo(url);
        },
        // 图标配置项
        DrawEcharts() {
            console.log(this.$refs.eCharts1);
            this.echartsStr = this.$echarts.init(this.$refs.eCharts1);
            this.echartsStr.setOption({
                darkMode: " auto",
                colorBy: "series",
                color: this.color,
                // backgroundColor: '#100C2A',
                title: {
                    text: "训练分析",
                    left: "3%",
                    top: "3%"
                }, //标题位置

                tooltip: {
                    trigger: "item"
                }, //提示框组件 ---数据项图形触发
                legend: {
                    // orient: 'vertical', //图标列表的布局朝向
                    right: "3%",
                    top: "3%",
                    data: ["训练分析"]
                },
                radar: {
                    // shape: 'circle',
                    indicator: this.echartsStrValue.data
                },
                series: [
                    {
                        type: "radar",
                        radius: "80%",
                        data: [
                            {
                                value: this.echartsStrValue.xdata,
                                name: "训练分析"
                            }
                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            });
        },

        handelDetail(row) {
            this.echartsStrValue = {
                xdata: [],
                data: []
            };
            var maxNum = "";
            this.getYcAiTrainUserDetails({ yatuId: row.yatuId }).result(
                res => {
                    console.log(res);
                    if (res.data.data) {
                        if (res.data.data.yuamrAnswerEvaluate) {
                            JSON.parse(res.data.data.yuamrAnswerEvaluate).forEach(
                                (item, index) => {
                                    this.echartsStrValue.xdata = item.secondArray
                                    item.firstArray.forEach(
                                        (items, index) => {
                                            this.echartsStrValue.data.push({
                                                name: items,
                                                max: ""
                                            });
                                        }
                                    );
                                }
                            );
                            maxNum = Math.max(...this.echartsStrValue.xdata);
                            this.echartsStrValue.data.forEach(item => {
                                item.max = maxNum;
                            });
                        }
                        this.detailArr = res.data.data;
                        this.$nextTick(() => {
                            this.DrawEcharts();
                        });

                        this.viedoDet = true;
                    }
                }
            );
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData();
        },
        getData() {
            this.getYcAiTrainUserList({
                projectId: this.theProjectId,
                mtmId: this.mtmId,
                microlectureTitle: this.microlectureTitle,
                yatuStatus: this.yatuStatus,
                dtId: this.dtId,
                ymtmTimeSubmitStart: this.ymtmTimeSubmitStart,
                ymtmTimeSubmitEnd: this.ymtmTimeSubmitEnd,
                yatbId: this.theYatbId,
                examType: this.examType,
                currentPage: 1
            });
        }
    },

    async created() {
        // this.getYcAiTrainBaseList({pageSize:0}).result(res => {
        //     if (res.data.data) {
        //         this.$nextTick(() => {
        //             this.getYcAiTrainBaseList_data = res.data.data;
        //         });
        //         console.log(res.data.data);
        //     }
        // });
        this.getYcAiTrainBaseList({ pageSize: 0 });
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getYcAiTrainUserList({ projectId: A.local("$projectId") });
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/AiAgent/AiScencReord.vue